import { useCallback, useEffect, useRef, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import getTimeDiffInDays from "../utils/getTimeDiffInDays"
import getTimeDiffFaString from "../utils/getTimeDiffFaString"
import { APP_ROUTES } from "../utils/constants"
import actionHelper from "../lib/actionHelper"
import { toast } from "react-toastify"
import Table from "../components/Table"
import AutoRenewButton from "../components/Jts3Users/AutoRenewButton"
import Jts3UserMoreModal from "../components/Jts3Users/Jts3UserMoreModal"
import CreateJts3UserModal from "../components/Jts3Users/CreateJts3UserModal"
import { useAuth } from "../lib/useAuth"
import { useSocket, useSocketEvent } from "../contexts/SocketContext"
import { EyeOutlined } from "@ant-design/icons"
import sidebarStore from "../store/sidebarStore"

const cols = [
    {
        name: "حالت",
        colSpan: 1,
    },

    {
        name: "ایمیل",
        colSpan: 1,
    },

    {
        name: "نام کاربری",
        colSpan: 1,
    },
    {
        name: "پسورد",
        colSpan: 1,
    },
    {
        name: "تاریخ انقضا",
        colSpan: 1,
    },
    {
        name: "تمدید اتومات",
        colSpan: 1,
    },

    {
        name: "تنظیمات",
        colSpan: 1,
    },
]

const Jts3Users = () => {
    const { user, loading } = useAuth()
    const { isConnected, sendMessage } = useSocket()
    const companyDomainName = useRef()

    const navigate = useNavigate()

    const [jts3UserList, setJts3UserList] = useState([])
    const [rows, setRows] = useState([])
    const [createIsOpen, setCreateIsOpen] = useState(false)
    const [searchBar, setSearchBar] = useState("")
    const setSection = sidebarStore((state) => state.setSection)

    const searchBarChangeHandler = async (e) => {
        await new Promise((resolve) => setTimeout(resolve, 500))
        setSearchBar(e.target.value)
    }

    useEffect(() => {
        if (user) {
            companyDomainName.current = user?.companyDomainName
        }
    }, [loading])

    const toggleCreate = () => {
        setCreateIsOpen(!createIsOpen)
    }

    const createRows = (jts3Users) => {
        return jts3Users?.map((user) => {
            const now = new Date()
            const createdDate = new Date(user.created)
            const expireDate = new Date(user.expires)
            const expires = user.expires == null ? null : getTimeDiffInDays(expireDate, now)
            user.expString = user.expires == null ? null : getTimeDiffFaString(expireDate, now)
            user.crtString = getTimeDiffFaString(createdDate, now)

            let obj = {
                id: user.id,
                state: (
                    <span className={user.state == "active" ? "bg-blur-success" : "bg-blur-warning"}>
                        {user.state == "active" ? "فعال" : "غیرفعال"}
                    </span>
                ),
                email: user.email,

                username: user.username,
                password: user.password,
                expString:
                    expires !== null ? (
                        <span className={expires >= 0 ? "text-success" : "text-danger"}>{user.expString}</span>
                    ) : (
                        <span>دائمی</span>
                    ),
                renew: <AutoRenewButton jts3User={user} />,
                more: (
                    <div className="flex gap-2">
                        <Jts3UserMoreModal jts3User={user} />
                        <a href={`https://jts3.${companyDomainName.current}/`} target="_blank">
                            <EyeOutlined style={{ fontSize: "20px" }} />
                        </a>
                    </div>
                ),
            }
            console.log(obj)
            return obj
        })
    }

    const handleUserList = useCallback((data) => {
        setJts3UserList(data)
    }, [])

    const handleUserAdded = useCallback((nsewUser) => {
        setJts3UserList((list) => [...list, nsewUser])
    }, [])

    const handleUserUpdated = useCallback((newData) => {
        setJts3UserList((oldUserList) => {
            return oldUserList.map((s) => {
                return s.id == newData.id ? Object.assign(s, newData) : s
            })
        })
    }, [])

    const handleUserDeleted = useCallback((deletedId) => {
        setJts3UserList((oldUserList) => {
            return oldUserList.filter((s) => s.id != deletedId)
        })
    }, [])

    useSocketEvent("jts3UserList", handleUserList)
    useSocketEvent("jts3UserAdded", handleUserAdded)
    useSocketEvent("jts3UserUpdated", handleUserUpdated)
    useSocketEvent("jts3UserDeleted", handleUserDeleted)

    const handleRefresh = () => {
        sendMessage("getJts3UserList")
    }

    useEffect(() => {
        if (!isConnected) {
            return
        }

        if (user && user.can_use_jts3) {
            sendMessage("getJts3UserList")
        } else if (user && user.can_use_servers) {
            navigate(APP_ROUTES.INDEX)
        } else if (user && user.can_use_manager_bots) {
            navigate(APP_ROUTES.TS_MANAGER_BOTS)
        } else if (user && user.can_use_bot) {
            navigate(APP_ROUTES.MUSIC_BOTS)
        } else if (user) {
            toast.error("شما هیچگونه دسترسی ندارید")
            localStorage.clear()
            navigate(APP_ROUTES.SIGN_IN)
        } else {
            return
        }
    }, [isConnected])

    useEffect(() => {
        if (searchBar && searchBar !== "" && jts3UserList) {
            let searchedRows = jts3UserList.filter((user) => {
                if (
                    !user.username?.toString().includes(searchBar) &&
                    !user.email?.toString().includes(searchBar) &&
                    !user.author?.toString().includes(searchBar)
                ) {
                    return false
                } else {
                    return true
                }
            })
            setRows(createRows(searchedRows))
        } else if (jts3UserList) {
            setRows(createRows(jts3UserList))
        }
    }, [searchBar, jts3UserList])

    const section = {
        title: "کاربران jts3",
        setSearchBar: searchBarChangeHandler,
        buttons: [
            {
                name: "ساخت کاربر جدید",
                onClick: toggleCreate,
                color: "border",
                iconName: "square-plus",
            },
        ],
    }

    if (!user) {
        return "Loading..."
    }

    setSection(section)

    return (
        <>
            <CreateJts3UserModal user={user} isOpen={createIsOpen} toggleModal={toggleCreate} />
            <Table cols={cols} rows={rows} paging={{ maxRows: 10 }} handleRefresh={handleRefresh} />
        </>
    )
}

export default Jts3Users
